import moment from 'moment'

export default {
  namespaced: true,
  state: {
    selectedWork: undefined,
    worksData: undefined,
    loading: false,
    seenComments: []
  },
  getters: {
    state: (state) => state
  },
  actions: {
    setLoading ({ commit }, loading) {
      commit('setLoading', loading)
    },
    removeWork ({ commit }, index) {
      commit('removeWork', index)
    },
    addWork ({ commit }, work) {
      commit('addWork', work)
    },
    setWorksData ({ commit }, worksData) {
      commit('setWorksData', worksData)
    },
    setSelectedWork ({ commit }, work) {
      commit('setSelectedWork', work)
    },
    sortWorksNonChronological ({ state }) {
      state.worksData.sort((a, b) => {
        return moment(b.dateCreation, 'DD.MM.YYYY') - moment(a.dateCreation, 'DD.MM.YYYY')
      })
    },
    addSeenComments ({ commit }, comment) {
      commit('addSeenComments', comment)
    },
    removeSeenComment ({ commit }, index) {
      commit('removeSeenComment', index)
    },
    resetSeenComment ({ commit }) {
      commit('resetSeenComment')
    }
  },
  mutations: {
    setLoading (state, loading) {
      state.loading = loading
    },
    removeWork (state, index) {
      state.worksData.splice(index, 1)
    },
    addWork (state, work) {
      state.worksData.push(work)
    },
    setWorksData (state, worksData) {
      state.worksData = worksData
    },
    setSelectedWork (state, work) {
      state.selectedWork = work
    },
    addSeenComments (state, comment) {
      state.seenComments.push(comment)
    },
    removeSeenComment (state, index) {
      state.seenComments.splice(index, 1)
    },
    resetSeenComment (state) {
      state.seenComments = []
    }
  }
}
